import i18n from '@/utils/i18n';
import React from 'react';
import { AnimatedSkeletonLoader } from '@usepepper/ui/atoms/animated-skeleton-loader';
import { useIsMobileBottomNavLayout } from '@sales-portal/blocs/hooks/use-is-mobile-bottom-nav-layout';
import { useTheme } from '@/contexts/theme-context';
import { XStack, YStack } from '@usepepper/sprout-kit-ui';

const METRIC_COUNT = 3;
const LABEL_WIDTH = 72;
const LABEL_HEIGHT = 12;
const VALUE_WIDTH = 58;
const VALUE_HEIGHT = 16;
const LIST_LABEL_WIDTH = 104;
const LIST_LABEL_HEIGHT = 14;
const DATA_BOX_MIN_HEIGHT = 64;

export const AccountDetailMetricsSkeleton: React.FC = () => {
  const isMobileBottomNavLayout = useIsMobileBottomNavLayout();
  const theme = useTheme();
  const barRadius = theme.sk.radii.radiusRound;

  if (!isMobileBottomNavLayout) {
    return (
      <XStack
        accessibilityLabel={i18n.t(
          'sales_portal.account_detail.metrics.loading',
        )}
        accessibilityRole="progressbar"
        gap="$8"
      >
        {Array.from({ length: METRIC_COUNT }).map((_, index) => (
          <YStack
            backgroundColor="$bgPrimaryDefault"
            borderColor="$borderPrimary"
            borderRadius="$8"
            borderWidth={1}
            flex={1}
            gap="$4"
            key={index}
            minHeight={DATA_BOX_MIN_HEIGHT}
            overflow="hidden"
            paddingHorizontal="$16"
            paddingVertical="$8"
          >
            <AnimatedSkeletonLoader
              borderRadius={barRadius}
              height={LABEL_HEIGHT}
              width={LABEL_WIDTH}
            />
            <AnimatedSkeletonLoader
              borderRadius={barRadius}
              height={VALUE_HEIGHT}
              width={VALUE_WIDTH}
            />
          </YStack>
        ))}
      </XStack>
    );
  }

  return (
    <YStack
      accessibilityLabel={i18n.t('sales_portal.account_detail.metrics.loading')}
      accessibilityRole="progressbar"
      borderColor="$borderPrimary"
      borderRadius="$8"
      borderWidth={1}
      overflow="hidden"
    >
      {Array.from({ length: METRIC_COUNT }).map((_, index) => (
        <XStack
          alignItems="flex-start"
          borderTopColor="$borderPrimary"
          borderTopWidth={index === 0 ? 0 : 1}
          justifyContent="space-between"
          key={index}
          paddingHorizontal="$16"
          paddingVertical="$16"
        >
          <AnimatedSkeletonLoader
            borderRadius={barRadius}
            height={LIST_LABEL_HEIGHT}
            width={LIST_LABEL_WIDTH}
          />
          <AnimatedSkeletonLoader
            borderRadius={barRadius}
            height={VALUE_HEIGHT}
            width={VALUE_WIDTH}
          />
        </XStack>
      ))}
    </YStack>
  );
};
